import isColorDark from './isColorDark';
export default isColorDark;